import React from 'react';
import { Body, Title } from '@cognite/cogs.js';
import { Row, Col } from 'antd';
import styled from 'styled-components/macro';

type TitleBarProps = {
  heading: string;
  subheading: React.ReactNode;
  children?: React.ReactNode;
};

export const TitleBar = ({ heading, subheading, children }: TitleBarProps) => (
  <StyledRow>
    <Col flex={1}>
      <Title level={3}>{heading}</Title>
      <StyledIntroText>{subheading}</StyledIntroText>
    </Col>
    {children}
  </StyledRow>
);

const StyledRow = styled(Row)`
  margin: 2rem;
  gap: 0.5rem;
  align-items: center;
`;

const StyledIntroText = styled(Body)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  width: 70%;
`;
